/* 에러 메시지 */
export const COMM_ERROR_TITLE = "오류";

export const COMM_REQUIRE_LOGIN = "로그인이 필요합니다. 로그인 하시겠습니까?";

export const COMM_ERROR_MESSAGE = "일시적인(네트워크) 오류입니다.<br/>잠시후 다시 이용해 주시기 바랍니다.";
export const COMM_UNKNOWN_MESSAGE = "알수 없는 오류가 발생하였습니다.<br/>재시도 후에도 계속해서 문제가 발생할 경우 고객센터(1588-1440)로 연락해 주세요";
export const COMM_ERROR_SERVER_RESPONSE = "서버 오류 (잘못된 형식 or 포맷) 입니다.<br/>잠시후 다시 이용해 주시기 바랍니다.";

export const COMM_SALES_HOLDER = "ARO 신규 신청이 제한된 회원입니다. 자세한 사항은 고객센터(1588-1440)로 연락 주시기 바랍니다."
export const COMM_SALES_TYPE_DIST_TEMP = "ARO 신규 신청은 등록 확인서 제출 후 이용 가능합니다. 자세한 사항은 고객센터(1588-1440)로 연락 주시기 바랍니다."



// WEBPACK FOOTER //
// ./src/utils/error_msg.js